import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import fr from "./fr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, fr: { translation: fr } },
    fallbackLng: "en",
    // Without these the language stayed the browser's full code ("fr-FR"),
    // which every `language === "fr"` test and the report API missed.
    // Each detected code is cut to its language first: supportedLngs alone
    // looks for an exact match across ALL detected codes before trying
    // "fr" for "fr-FR", so a browser listing ["fr-FR", "en-US", "en"]
    // would have been switched to English.
    supportedLngs: ["en", "fr"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => String(lng).split(/[-_]/)[0].toLowerCase(),
    },
  });

export default i18n;
